export const PROFILE_TOPIC_NAMES = {
    WORKING_WITH_ME: "How to Work With Me",
    TEAM_WORK: "How My Team Should Work",
} as const;

export type ProfileTopicName = (typeof PROFILE_TOPIC_NAMES)[keyof typeof PROFILE_TOPIC_NAMES];
